import styled from '@emotion/styled';
import { color } from 'src/shared/styles/variables';

export const ScreenWrapper = styled.div({
    backgroundColor: color.white,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    alignItems: 'center',
    overflowY: 'scroll',
});
